export const apiConstants = {
    'get_client_details': 'details',
    'merchant_info': 'merchant-info',
    'principal_info': 'principal-info',
    'address_info': 'address-info',
    'other_merchant_info': 'other-info',
    'bank_info': 'bank-info',
    'financial_info': 'financial-info',
    'pricing_info': 'pricing-info',
	'lending_info': 'lending-info',
    'list_client_status_options':  'status/client/list',
};
